import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Editor } from "primereact/editor";
import { useParams } from "react-router-dom";


import api from "../../services/api";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Typography,
  Divider,
  Paper,
} from "@material-ui/core";

import "./styles.css";

import { useAlert } from "react-alert";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { toast } from "react-toastify";

const useStyles = makeStyles({
  inputStyle: {
    margin: "5px",
  },
  inputClienteStyle: {
    margin: "5px",
    width: "500px",
  },
  buttonStyle: {
    margin: "5px",
    marginTop: "30px",
    marginBottom: "30px",
  },
  titleStyle: {
    margin: "15px",
    marginTop: "2200px",
  },
  smallTitleStyle: {
    margin: "10px",
    color: "#002884",
  },
  smallerTitleStyle: {
    marginLeft: "12px",
    marginTop: "12px",
  },
  dividerStyle: {
    margin: "25px",
    color: "#006998",
  },
  iconStyle: {
    fontSize: "12px",
  },
  descriptionIconStyle: {
    color: "#388e3c",
  },
});

function EditarAta() {
  const history = useHistory();
  const classes = useStyles();
  const alert = useAlert();

  const [ setAssunto] = useState("");

  const [participantesFN, setParticipantesFN] = useState([{ emailFN: "" }]);

  const [participantesClientes, setParticipantesClientes] = useState([
    { emailCliente: "" },
  ]);

  const [ setDate] = useState(null);

  const [projeto, setNomeProjetos] = useState([]);
  const [ setProjetoSelected] = useState("");
  const handleChangeProjeto = (event) => {
    setProjetoSelected(event.target.value);
    console.log(event.target.value);
  };

  const [cliente, setCliente] = useState([]);
  const [clienteSelected, setClienteSelected] = useState("");
  const handleChangeCliente = (event) => {
    console.log(event.target.value);

    setClienteSelected(event.target.value);
    console.log(clienteSelected);
  };
  const [pontosAbordados, setPontosAbordados] = useState([
    {
      item: "",
      editorValue: "",
    },
  ]);

  const [ setPontosAbordadosSelected] = useState("");

  const handleChangePontosAbordados = (event) => {
    setPontosAbordadosSelected(event.target.value);
  };

  const handleAddPontoAbordado = () => {
    setPontosAbordados([...pontosAbordados, { item: "", editorValue: "" }]);
  };

  const handleRemovePontoAbordado = (index) => {
    if (pontosAbordados.length > 1) {
      const updatedPontosAbordados = pontosAbordados.filter(
        (_, i) => i !== index
      );
      setPontosAbordados(updatedPontosAbordados);
    }
  };

  const [proximosPassos, setProximosPassos] = useState([
    {
      responsavel: "",
      tarefa: "",
      editorValue: "",
      codigoRedmine: "",
      prazo: null,
      atividade: [""],
    },
  ]);

  const [tempoInicial, setTempoInicial] = useState(null);

  const [tempoFinal, setTempoFinal] = useState(null);
  const [ setDuracao] = useState(null);

  const calcularDuracaoHorasArredondadas = (inicio, fim) => {
    if (inicio && fim && fim > inicio) {
      const diff = Math.abs(fim.getTime() - inicio.getTime());
      const horas = diff / (1000 * 60 * 60);
      const horasArredondadas = Math.round(horas);
      setDuracao(horasArredondadas);
    } else {
      setDuracao(null);
    }
  };

  const handleTempoInicialChange = (e) => {
    setTempoInicial(e.value);
    console.log("Tempo Inicial:", e.value);
    calcularDuracaoHorasArredondadas(e.value, tempoFinal);
  };

  const handleTempoFinalChange = (e) => {
    setTempoFinal(e.value);
    calcularDuracaoHorasArredondadas(tempoInicial, e.value);
  };

  useEffect(() => {
    const buscarProjetos = async () => {
      try {
        const response = await api.get("/api/buscarProjetos");
        setNomeProjetos(response.data);
        console.log(projeto);
      } catch (error) {
        console.error("Erro ao buscar Projetos:", error);
      }
    };

    buscarProjetos();
  }, [projeto]);

  useEffect(() => {
    const buscarClientes = async () => {
      try {
        const response = await api.get("/api/buscarClientes");
        setCliente(response.data);
        
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };

    buscarClientes();
  }, []);

  const [ata, setAta] = useState(null);

  const { ataId } = useParams();
  const token = localStorage.getItem("auth-token");

  useEffect(() => {
    const buscarAta = async () => {
      try {
        console.log("IdAta", ataId);
        const response = await api.get(`/api/ata/minhas/${ataId}`, {
          headers: {
            "X-Auth-Token": token,
            "content-type": "application/json",
          },
        });
        setAta(response.data);
      } catch (error) {
        console.error("Erro ao buscar ata:", error);
      }
    };

    buscarAta();
  }, [ataId, token]);

  console.log(ata);

  const [ setDecisoesTomadas] = useState("");

  const [decisoes, setDecisoes] = useState([
    {
      decisoes: "",
      itemReferente: "",
      linkAtividades: "",
    },
  ]);

  const handleChange = (index, field, value) => {
    const newDecisoes = [...decisoes];
    newDecisoes[index][field] = value;
    console.log(newDecisoes);
    setDecisoes(newDecisoes);
  };

  const handleAddFields = () => {
    setDecisoes([
      ...decisoes,
      {
        decisoes: "",
        itemReferente: "",
        linkAtividades: "",
      },
    ]);
  };

  const handleRemoveFields = (index) => {
    if (decisoes.length > 1) {
      const newDecisoes = [...decisoes];
      newDecisoes.splice(index, 1);
      setDecisoes(newDecisoes);
    }
  };

  async function submitHandler(e) {
    e.preventDefault();
    try {
      toast.success(
        <CustomToast message="Sua ata foi alterada com sucesso" />,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
      setCliente([]);
      setAssunto("");
      setParticipantesFN([]);
      setParticipantesClientes([]);
      setPontosAbordados([
        {
          item: "",
          editorValue: "",
        },
      ]);
      setDecisoesTomadas("");
      setProximosPassos([]);
      history.push("/perfil");
    } catch (err) {
      alert.show(
        "Erro ao criar uma nova ata de reunião. Por favor, tente novamente.",
        { title: "Algo deu errado.", closeCopy: "OK" }
      );
    }
  }
  const headerActions = [
    { display: "clientes", label: "Clientes", style: { marginLeft: "132px" } },
    {
      display: "fabrica",
      label: "Fábrica ",
      style: { marginLeft: "200px" },
    },
    // { path: '', label: 'Imagens' },
  ];

  const [participantesForm, setParticipantesForm] = useState("clientes");

  console.log("ataa", ata);
  //FN
  const handleChangeInputFN = (index, event) => {
    const values = [...participantesFN];
    console.log(values[index], values, index);
    values[index]["emailFN"] = event.target.value;
    setParticipantesFN(values);
  };

  const handleAddFieldsFN = () => {
    setParticipantesFN([...participantesFN, { emailFN: "" }]);
  };

  const handleRemoveFieldsFN = (index) => {
    if (participantesFN.length > 1) {
      const values = [...participantesFN];
      values.splice(index, 1);
      setParticipantesFN(values);
    }
  };

  // Clientes
  const handleChangeInputClientes = (index, event) => {
    const values = [...participantesClientes];
    values[index]["emailCliente"] = event.target.value;
    setParticipantesClientes(values);
  };

  const handleAddFieldsClientes = () => {
    setParticipantesClientes([...participantesClientes, { emailCliente: "" }]);
    console.log("participantesClientes", participantesClientes);
  };

  const handleRemoveFieldsClientes = (index) => {
      const values = [...participantesClientes];
      values.splice(index, 1);
      setParticipantesClientes(values);
    
  };

  // Proximos passos

  const handleChangeInputProximosPassos = (index, event, field) => {
    const values = [...proximosPassos];
    console.log({ values, field, index });
    values[index][field] = event.target.value;
    setProximosPassos(values);
  };

  const handleAddFieldsProximosPassos = () => {
    setProximosPassos([
      ...proximosPassos,
      {
        responsavel: "",
        tarefa: "",
        editorValue: "",
        codigoRedmine: "",
        prazo: null,
        atividade: [""],
      },
    ]);
  };

  console.log(proximosPassos);

  const handleRemoveFieldsProximosPassos = (index) => {
    if (proximosPassos.length > 1) {
      const updatedProximosPassos = proximosPassos.filter(
        (_, i) => i !== index
      );
      setProximosPassos(updatedProximosPassos);
    }
  };
  const [isEnabled, setIsEnabled] = useState(true);

  const handleHabilitarEdicao = () => {
    setIsEnabled((prev) => !prev);
  };

  const [atas, setAtas] = useState([]);

  //MODAL DE CANCELAMENTO
  const [mostrarModal, setMostrarModal] = useState(false);

  const handleCancelarClick = () => {
    setMostrarModal(true);
  };

  const handleConfirmarCancelamento = () => {
    setMostrarModal(false);
    history.push("/documentos-ata");
  };

  const handleCancelarModal = () => {
    setMostrarModal(false);
  };

  const CustomToast = ({ message, icon }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      {icon && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="21"
          viewBox="0 0 22 21"
          fill="none"
          style={{ marginRight: "8px" }}
        >
          <path
            d="M16.75 20.16L14 17.16L15.16 16L16.75 17.59L20.34 14L21.5 15.41L16.75 20.16ZM9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C15.5 0 20 4.5 20 10L19.92 11.31C19.31 11.11 18.67 11 17.94 11L18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C10.71 18 11.39 17.91 12.05 17.74C12.13 18.42 12.33 19.06 12.62 19.65C11.78 19.88 10.9 20 10 20C4.47 20 0 15.5 0 10C0 4.5 4.47 0 10 0Z"
            fill="#3900DB"
          />
        </svg>
      )}
      <span>{message}</span>
    </div>
  );

  const handleBaixarDocumento = () => {
    // Adiciona o toast.info dentro da função onClick

    // Após exibir o toast, redireciona para a nova página
    history.push("/ata-pdf/" + ataId);
  };

  const handleEnviarLixeira = async (ata) => {
    try {
      const updatedAtas = atas.map((item) =>
        item._id === ata._id ? { ...item, trash: true } : item
      );
      setAtas(updatedAtas);

      await api.put(`/api/atas/${ata._id}`);

      console.log("Depois da requisição PUT:", ata);

      history.push("/atas-excluidas");

      // Adiciona a notificação de sucesso
      toast.info(
        <CustomToast message="Ata movida para lixeira" icon={true} />,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    } catch (error) {
      console.error("Erro ao restaurar ata:", error);
      // Adiciona a notificação de erro
      toast.error("Erro ao encaminhar a ata para a lixeira!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  return (
    <div elevation={6} style={{ height: "100vh", justifyContent: "center" }}>
      <div className="form-container1">
        <div>
          <Typography
            className={classes.titleStyle}
            align="center"
            variant="h5"
          >
            <p
              style={{
                fontSize: "35px",
                fontStyle: "normal",
                fontWeight: "700",
                color: "#006998",
                marginTop: "-4px",
              }}
            >
              _{ata?.cliente}_{ata?.projeto}_{ata?.date}_ATA
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginRight: "500px",
              }}
            >
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="108"
                  height="23"
                  viewBox="0 0 108 23"
                  fill="none"
                  onClick={handleHabilitarEdicao}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    d="M22.6263 5.1647C23.1246 4.66644 23.1246 3.836 22.6263 3.36328L19.6367 0.373698C19.164 -0.124566 18.3336 -0.124566 17.8353 0.373698L15.4845 2.71171L20.2755 7.50271M0 18.209V23H4.791L18.9213 8.85696L14.1303 4.06596L0 18.209Z"
                    fill="#B7D400"
                  />
                </svg>
              </div>

              <div style={{ marginLeft: "-39px" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="108"
                  height="23"
                  viewBox="0 0 108 23"
                  fill="none"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleEnviarLixeira(ata)}
                >
                  <path
                    d="M49.5625 0V1.27778H43V3.83333H44.3125V20.4444C44.3125 21.1222 44.5891 21.7722 45.0813 22.2515C45.5736 22.7308 46.2413 23 46.9375 23H60.0625C60.7587 23 61.4264 22.7308 61.9187 22.2515C62.4109 21.7722 62.6875 21.1222 62.6875 20.4444V3.83333H64V1.27778H57.4375V0H49.5625ZM49.5625 6.38889H52.1875V17.8889H49.5625V6.38889ZM54.8125 6.38889H57.4375V17.8889H54.8125V6.38889Z"
                    fill="#EC0000"
                  />
                </svg>
              </div>

              <div style={{ width: "70px", marginLeft: "-42px" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="108"
                  height="23"
                  viewBox="0 0 108 23"
                  fill="none"
                  style={{ cursor: "pointer" }}
                  onClick={handleBaixarDocumento}
                >
                  <path
                    d="M81 13.5294H83.7V20.2941H105.3V13.5294H108V20.2941C108 21.7959 106.799 23 105.3 23H83.7C82.215 23 81 21.7959 81 20.2941V13.5294ZM94.5 17.5882L101.992 10.2012L100.075 8.29353L95.85 12.5147V0H93.15V12.5147L88.938 8.29353L87.021 10.2147L94.5 17.5882Z"
                    fill="#006998"
                  />
                </svg>
              </div>
            </div>

            {/* <DescriptionOutlined
              className={classes.descriptionIconStyle}
              fontSize="small"
            /> */}
          </Typography>
          <Paper
            style={{
              color: "#3900DB",

              fontSize: "1rem",
              fontFamily: "DM Sans",
              fontWeight: 700,
              width: "70rem",
              padding: "2rem",

              letterSpacing: "0.00938em",
              margin: "0px",
              borderRadius: "16px",
              background: "#F2FBFF",

              marginLeft: "15px",
            }}
          >
            <p
              style={{
                fontSize: "25px",
                fontStyle: "normal",
                fontWeight: "700",
                color: "#006998",
                marginTop: "-4px",
                marginLeft: "50px",
              }}
            >
              Informações Básicas *
            </p>

            <div
              style={{
                display: "flex",
                marginBottom: "1rem",
                marginLeft: "45px",
                gap: "10px",
                marginTop: "98px",
              }}
            >
              <fieldset
                style={{
                  borderRadius: "4px",
                  borderColor: "#006998",
                  width: "200px",
                }}
              >
                <legend
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "black",
                    marginLeft: "35px",
                  }}
                >
                  Tempo Inicial
                </legend>
                <Calendar
                  style={{
                    border: "none",

                    height: "2px",

                    backgroundColor: "#F2FBFF",
                  }}
                  inputStyle={{
                    backgroundColor: "#F2FBFF",
                    border: "none",
                  }}
                  id="calendar-timeonly"
                  value={ata?.tempoInicial ? new Date(ata.tempoInicial) : null}
                  onChange={handleTempoInicialChange}
                  timeOnly
                  required
                  disabled
                />
              </fieldset>
              <fieldset
                style={{
                  borderRadius: "4px",
                  borderColor: "#006998",
                  width: "200px",
                }}
              >
                <legend
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "black",
                    marginLeft: "35px",
                  }}
                >
                  Tempo Final
                </legend>

                <Calendar
                  style={{
                    height: "10px",

                    borderRadius: 6,
                    backgroundColor: "#F2FBFF",
                  }}
                  inputStyle={{
                    backgroundColor: "#F2FBFF",
                    border: "none",
                  }}
                  id="calendar-timeonly"
                  value={ata?.tempoFinal ? new Date(ata.tempoFinal) : null}
                  onChange={handleTempoFinalChange}
                  timeOnly
                  disabled
                />
              </fieldset>

              <Button
                label={`Duração: ${ata?.duracao} horas`}
                className="p-button-outlined p-button-primary"
                style={{
                  color: "#006998",

                  borderRadius: "4px",
                  width: "200px",
                  height: "54px",
                  marginTop: "8px",
                  fontSize: "20px",
                }}
                disabled
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "1rem",
                marginLeft: "45px",
                gap: "10px",
              }}
            >
              <fieldset
                style={{
                  borderRadius: "4px",
                  borderColor: "#006998",
                  width: "200px",
                }}
              >
                <legend
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "black",
                    marginLeft: "40px",
                    //TODO: Ajuste do marginLeft para centralizar a legenda
                  }}
                >
                  Cliente
                </legend>
                <select
                  style={{
                    border: "none",
                    fontStyle: "italic",
                    fontWeight: "400",
                    color: "#858585",
                    marginLeft: "5px", // TODO: Ajuste do marginLeft
                    fontSize: "14px",
                    backgroundColor: "#F2FBFF",
                  }}
                  disabled
                  value={ata?.cliente || ""}
                  onChange={handleChangeCliente}
                  required
                >
                  <option value="">Selecione o cliente</option>
                  {cliente.map((cliente) => (
                    <option
                      key={cliente.nome_clientes}
                      value={cliente.nome_clientes}
                    >
                      {cliente.nome_clientes}
                    </option>
                  ))}
                </select>
              </fieldset>
              <fieldset
                style={{
                  borderRadius: "4px",
                  borderColor: "#006998",
                  width: "200px",
                }}
              >
                <legend
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "black",
                    marginLeft: "45px", // TODO: Ajuste do marginLeft para centralizar a legenda
                  }}
                >
                  Projeto
                </legend>
                <select
                  style={{
                    border: "none",
                    fontStyle: "italic",
                    fontWeight: "400",
                    color: "#858585",

                    fontSize: "14px",
                    backgroundColor: "#F2FBFF",
                  }}
                  disabled
                  value={ata?.projeto || ""}
                  onChange={handleChangeProjeto}
                  required
                >
                  <option value="">Selecione o Projeto</option>
                  {projeto.map((projeto) => (
                    <option
                      key={projeto.nome_projeto}
                      value={projeto.nome_projeto}
                    >
                      {projeto.nome_projeto}
                    </option>
                  ))}
                </select>
              </fieldset>
              <fieldset
                style={{
                  borderRadius: "4px",
                  borderColor: "#006998",
                  width: "200px",
                }}
              >
                <legend
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "black",
                    marginLeft: "50px",
                  }}
                >
                  Data
                </legend>
                <div style={{}} className="card flex justify-content-center">
                  <span
                    style={{
                      fontWeight: "400",
                      fontSize: "15px",
                      color: "black",
                    }}
                    className="p-float-label"
                  >
                    <Calendar
                      style={{
                        justifyContent: "center",
                        border: "none",
                        height: "10px",
                      }}
                      inputStyle={{
                        backgroundColor: "#F2FBFF",
                        border: "none",
                      }}
                      inputId="birth_date"
                      dateFormat="dd/mm/yy"
                      value={ata?.date ? new Date(ata.date) : null}
                      onChange={(e) => setDate(e.value)}
                      required={true}
                      disabled
                    />
                  </span>
                </div>
              </fieldset>
            </div>
          </Paper>

          {/* <form onSubmit={submitHandler}>
            <TextField
              className={classes.inputStyle}
              label="Cliente"
              variant="outlined"
              required
              value={cliente}
              onChange={(e) => setCliente(e.target.value)}
            />
            <TextField
              className={classes.inputStyle}
              label="Assunto"
              variant="outlined"
              required
              value={assunto}
              onChange={(e) => setAssunto(e.target.value)}
            /> */}

          <Divider
            className={classes.dividerStyle}
            variant="fullWidth"
            style={{ backgroundColor: "rgba(0, 105, 152, 0.55)" }}
          />
          {/* 
            <Typography
              className={classes.smallTitleStyle}
              align="left"
              variant="overline"
            >
              Participantes <PeopleOutlined className={classes.iconStyle} />
            </Typography> */}
          <Paper
            style={{
              color: "#3900DB",

              fontSize: "1rem",
              fontFamily: "DM Sans",
              fontWeight: 700,
              width: "70rem",
              padding: "2rem",

              letterSpacing: "0.00938em",
              margin: "0px",
              borderRadius: "16px",
              background: "#F2FBFF",

              marginLeft: "15px",
            }}
          >
            <p
              style={{
                fontSize: "25px",
                fontStyle: "normal",
                fontWeight: "700",
                color: "#006998",
                marginTop: "-4px",
                marginLeft: "65px",
              }}
            >
              Participantes
            </p>

            <div>
              <div style={{ display: "flex", marginLeft: "9rem" }}>
                {headerActions.map((headerAction, i) => (
                  <div
                    key={i}
                    className="cursor-pointer bg-[#B7D400] p-1 px-10 ml-3"
                    style={{
                      background: "#F2FBFF",
                      border: "1px solid #006998",
                      padding: "10px",
                      alignItems: "center",
                      color:
                        participantesForm === headerAction.display
                          ? "#B7D400"
                          : "#006998",
                      borderBottom: "none",
                      marginLeft: "5px",
                      textDecoration:
                        participantesForm === headerAction.display
                          ? "underline"
                          : "",

                      fontSize: "18px",
                      width: "120px",
                      marginBottom: "-1px",
                      height: "2.5rem",
                      zIndex: 2,
                      position: "relative",
                      borderRadius: "3px",
                      display: "flex",
                      gap: "5px",
                      justifyContent: "center",
                    }}
                    // style={ router.asPath == headerAction.path ?
                    //     { background: 'white', border: '1px solid rgb(36, 0, 255)', color: 'rgb(36, 0, 255)', borderBottom: 'none', textDecoration: 'underline' } :
                    //     {}}
                    onClick={() => setParticipantesForm(headerAction.display)}
                  >
                    {headerAction.label}
                  </div>
                ))}
              </div>

              <DataTable
                value={participantesFN}
                tableStyle={{
                  border: "1px solid #006998",

                  marginLeft: "70px",
                  width: 900,
                  backgroundColor: "#F2FBFF",
                  height: "100px",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <Column
                  style={{ backgroundColor: "#F2FBFF", border: "none" }}
                  // header="Participantes"
                  body={() => (
                    <div>
                      {participantesForm === "clientes" && (
                        <div>
                          {ata?.participantesFN.map((rowData, rowIndex) => (
                            <div key={rowIndex}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <label style={{ fontWeight: "400" }}>
                                  Nome *
                                </label>
                                <TextField
                                  name="emailFN"
                                  className={classes.inputClienteStyle}
                                  variant="outlined"
                                  type="email"
                                  required
                                  value={rowData.emailFN}
                                  onChange={(e) =>
                                    handleChangeInputFN(rowIndex, e)
                                  }
                                  disabled={!isEnabled}
                                  style={{
                                    borderColor: "#006998",
                                    borderRadius: "4px",
                                  }}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    marginTop: "-36px",
                                    gap: "5px",
                                    marginLeft: "527px",
                                  }}
                                >
                                  <div style={{ marginTop: "2px" }}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="18"
                                      viewBox="0 0 16 18"
                                      fill="none"
                                      onClick={() =>
                                        handleRemoveFieldsFN(rowIndex)
                                      }
                                    >
                                      <path
                                        d="M5 0V1H0V3H1V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H13C13.5304 18 14.0391 17.7893 14.4142 17.4142C14.7893 17.0391 15 16.5304 15 16V3H16V1H11V0H5ZM5 5H7V14H5V5ZM9 5H11V14H9V5Z"
                                        fill="#EC0000"
                                      />
                                    </svg>
                                  </div>
                                  <div style={{ marginTop: "1px" }}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="21"
                                      viewBox="0 0 26 23"
                                      fill="none"
                                      onClick={() => handleAddFieldsFN()}
                                    >
                                      <rect
                                        width="26"
                                        height="21"
                                        rx="4"
                                        fill="#B7D400"
                                      />
                                      <path
                                        d="M20 13H14V19H12V13H6V11H12V5H14V11H20V13Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      {participantesForm === "fabrica" && (
                        <div>
                          {ata?.participantesClientes.map(
                            (rowData, rowIndex) => (
                              <div key={rowIndex}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <label style={{ fontWeight: "400" }}>
                                    Nome *
                                  </label>
                                  <TextField
                                    name="emailCliente"
                                    className={classes.inputClienteStyle}
                                    variant="outlined"
                                    type="email"
                                    required
                                    value={rowData.emailCliente}
                                    onChange={(e) =>
                                      handleChangeInputClientes(rowIndex, e)
                                    }
                                    disabled={!isEnabled}
                                    style={{ border: "#006998" }}
                                  />
                                  <div
                                    style={{
                                      display: "flex",
                                      marginTop: "-36px",
                                      gap: "5px",
                                      marginLeft: "527px",
                                    }}
                                  >
                                    <div style={{ marginTop: "2px" }}>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="18"
                                        viewBox="0 0 16 18"
                                        fill="none"
                                        onClick={() =>
                                          handleRemoveFieldsClientes(rowIndex)
                                        }
                                      >
                                        <path
                                          d="M5 0V1H0V3H1V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H13C13.5304 18 14.0391 17.7893 14.4142 17.4142C14.7893 17.0391 15 16.5304 15 16V3H16V1H11V0H5ZM5 5H7V14H5V5ZM9 5H11V14H9V5Z"
                                          fill="#EC0000"
                                        />
                                      </svg>
                                    </div>

                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="21"
                                      viewBox="0 0 26 23"
                                      fill="none"
                                      onClick={() => handleAddFieldsClientes()}
                                    >
                                      <rect
                                        width="24"
                                        height="21"
                                        rx="4"
                                        fill="#B7D400"
                                      />
                                      <path
                                        d="M20 13H14V19H12V13H6V11H12V5H14V11H20V13Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  )}
                />
              </DataTable>
            </div>
          </Paper>

          <Divider
            className={classes.dividerStyle}
            variant="fullWidth"
            style={{ backgroundColor: "rgba(0, 105, 152, 0.55)" }}
          />

          <Paper
            style={{
              color: "#3900DB",

              fontSize: "1rem",
              fontFamily: "DM Sans",
              fontWeight: 700,
              width: "70rem",
              padding: "4rem",

              letterSpacing: "0.00938em",
              margin: "0px",
              borderRadius: "16px",
              background: "#F2FBFF",

              marginLeft: "32px",
            }}
          >
            <div style={{ marginTop: "-20px" }}>
              <p
                style={{
                  fontSize: "25px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  color: "#006998",
                  marginTop: "-10px",
                }}
              >
                Pontos Abordados
              </p>
            </div>
            {pontosAbordados.map((ponto, index) => (
              <div key={index}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label
                    style={{ color: "black", fontWeight: "500" }}
                    htmlFor={`item-${index}`}
                  >
                    Item *
                  </label>
                  <InputText
                    style={{
                      fontWeight: "400",
                      backgroundColor: "#F2FBFF",
                      border: "1px solid #006998",
                      width: "400px",
                    }}
                    id="username"
                    aria-describedby="username-help"
                    value={ata?.pontosAbordados[index]?.item || ""}
                    onChange={handleChangePontosAbordados}
                    disabled={!isEnabled}
                  />
                  <div
                    style={{
                      display: "flex",
                      marginTop: "-36px",
                      gap: "5px",
                      marginLeft: "420px",
                    }}
                  >
                    <div style={{ marginTop: "2px" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="18"
                        viewBox="0 0 16 18"
                        fill="none"
                        onClick={() => handleRemovePontoAbordado(index)}
                      >
                        <path
                          d="M5 0V1H0V3H1V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H13C13.5304 18 14.0391 17.7893 14.4142 17.4142C14.7893 17.0391 15 16.5304 15 16V3H16V1H11V0H5ZM5 5H7V14H5V5ZM9 5H11V14H9V5Z"
                          fill="#EC0000"
                        />
                      </svg>
                    </div>
                    <div style={{ marginTop: "1px" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="21"
                        viewBox="0 0 26 23"
                        fill="none"
                        onClick={() => handleAddPontoAbordado(index)}
                      >
                        <rect width="26" height="23" rx="4" fill="#B7D400" />
                        <path
                          d="M20 13H14V19H12V13H6V11H12V5H14V11H20V13Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "48px" }}>
                  <Editor
                    value={ata?.pontosAbordados[index]?.editorValue || ""}
                    onTextChange={(e) => {
                      const updatedPontosAbordados = [...pontosAbordados];
                      updatedPontosAbordados[index].editorValue = e.textValue;
                      setPontosAbordados(updatedPontosAbordados);
                    }}
                    style={{
                      height: "152px",

                      background: "red",
                    }}
                    disabled={!isEnabled}
                  />

                  <div
                    style={{
                      borderBottom: "1px #006998 solid",
                      width: "50%",
                      marginLeft: "236px",
                      marginTop: "49px",
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </Paper>
          <Divider
            className={classes.dividerStyle}
            variant="fullWidth"
            style={{ backgroundColor: "rgba(0, 105, 152, 0.55)" }}
          />
          <Paper
            style={{
              color: "#3900DB",

              fontSize: "1rem",
              fontFamily: "DM Sans",
              fontWeight: 700,
              width: "70rem",
              padding: "4rem",

              letterSpacing: "0.00938em",
              margin: "0px",
              borderRadius: "16px",
              background: "#F2FBFF",

              marginLeft: "32px",
            }}
          >
            <p
              style={{
                fontSize: "25px",
                fontStyle: "normal",
                fontWeight: "700",
                color: "#006998",
                marginTop: "-21px",
              }}
            >
              Decisões Tomadas
            </p>
            <div>
              {decisoes.map((decisao, index) => (
                <div key={index}>
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginRight: "10px",
                        fontWeight: "500",
                      }}
                      htmlFor={`decisoesTomadas-${index}`}
                    >
                      Decisão
                    </label>
                    <InputText
                      style={{
                        backgroundColor: "#F2FBFF",
                        border: "1px solid #006998",
                        width: "400px",
                      }}
                      id={`decisoesTomadas-${index}`}
                      aria-describedby={`decisoesTomadas-help-${index}`}
                      value={ata?.decisoesTomadas[index]?.decisoes || ""}
                      onChange={(e) =>
                        handleChange(index, "decisoes", e.target.value)
                      }
                      disabled={!isEnabled}
                    />
                    <div
                      style={{
                        display: "flex",
                        marginTop: "-36px",
                        gap: "5px",
                        marginLeft: "422px",
                      }}
                    >
                      <div style={{ marginTop: "2px" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          onClick={() => handleRemoveFields(index)}
                        >
                          <path
                            d="M5 0V1H0V3H1V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H13C13.5304 18 14.0391 17.7893 14.4142 17.4142C14.7893 17.0391 15 16.5304 15 16V3H16V1H11V0H5ZM5 5H7V14H5V5ZM9 5H11V14H9V5Z"
                            fill="#EC0000"
                          />
                        </svg>
                      </div>
                      <div style={{ marginTop: "1px" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="21"
                          viewBox="0 0 26 23"
                          fill="none"
                          onClick={handleAddFields}
                        >
                          <rect width="26" height="23" rx="4" fill="#B7D400" />
                          <path
                            d="M20 13H14V19H12V13H6V11H12V5H14V11H20V13Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginRight: "10px",
                        fontWeight: "500",
                      }}
                      htmlFor={`itemReferente-${index}`}
                    >
                      Item referente
                    </label>
                    <InputText
                      style={{
                        backgroundColor: "#F2FBFF",
                        border: "1px solid #006998",
                        width: "400px",
                      }}
                      id={`itemReferente-${index}`}
                      aria-describedby={`itemReferente-help-${index}`}
                      value={ata?.decisoesTomadas[index]?.itemReferente || ""}
                      onChange={(e) =>
                        handleChange(index, "itemReferente", e.target.value)
                      }
                      disabled={!isEnabled}
                    />
                  </div>
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginRight: "10px",
                        fontWeight: "500",
                      }}
                      htmlFor={`linkAtividades-${index}`}
                      disabled={!isEnabled}
                    >
                      Link das atividades do taiga
                    </label>
                    <InputText
                      style={{
                        backgroundColor: "#F2FBFF",
                        border: "1px solid #006998",
                        width: "600px",
                      }}
                      id={`linkAtividades-${index}`}
                      aria-describedby={`linkAtividades-help-${index}`}
                      value={ata?.decisoesTomadas[index]?.linkAtividades || ""}
                      onChange={(e) =>
                        handleChange(index, "linkAtividades", e.target.value)
                      }
                      disabled={!isEnabled}
                    />
                  </div>

                  <div
                    style={{
                      borderBottom: "1px #006998 solid",
                      width: "50%",
                      marginLeft: "236px",
                      marginTop: "49px",
                    }}
                  ></div>
                </div>
              ))}
            </div>
          </Paper>
          <Divider
            className={classes.dividerStyle}
            variant="fullWidth"
            style={{ backgroundColor: "rgba(0, 105, 152, 0.55)" }}
          />

          {/* <Typography 
                            className={classes.smallTitleStyle} 
                            align="left" 
                            variant="overline"
                        >
                            Próximos Passos <NavigateNextOutlined className={classes.iconStyle}/>
                        </Typography> */}

          <div style={{ marginLeft: "10px" }}>
            <Paper
              style={{
                color: "#3900DB",

                fontSize: "1rem",
                fontFamily: "DM Sans",
                fontWeight: 700,
                width: "70rem",
                padding: "2rem",

                letterSpacing: "0.00938em",
                margin: "0px",
                borderRadius: "16px",
                background: "#F2FBFF",
                justifyContent: "center",
                textAlign: "center",

                marginLeft: "15px",
              }}
            >
              <p
                style={{
                  fontSize: "25px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  color: "#006998",
                  marginTop: "-4px",
                  marginRight: "700px",
                }}
              >
                Próximos passos
              </p>

              {proximosPassos?.map((atv, index) => (
                <div key={index}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 38,
                    }}
                  >
                    <fieldset
                      style={{
                        borderRadius: "4px",
                        borderColor: "#006998",
                        marginTop: "20px",
                        width: "400px",
                        marginLeft: "54px",
                      }}
                    >
                      <legend
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                          color: "black",
                          marginLeft: "-4px",
                        }}
                      >
                        Atividade
                      </legend>
                      <select
                        style={{
                          border: "none",
                          fontStyle: "italic",
                          fontWeight: "400",
                          color: "#858585",
                          marginLeft: "10px",
                          fontSize: "14px",
                          background: "#F2FBFF",
                        }}
                        value={ata?.proximosPassos[index]?.atividade || ""}
                        onChange={(e) =>
                          handleChangeInputProximosPassos(index, e, "atividade")
                        }
                        disabled={!isEnabled}
                      >
                        <option value="">Selecione o tipo da atividade</option>
                        <option value="projeto">Projeto</option>
                        <option value="estudo">Estudo</option>
                        <option value="bug">BUG</option>
                        <option value="melhoria e apoio">
                          Melhoria e Apoio
                        </option>
                      </select>
                    </fieldset>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      marginTop: "-59px",
                      gap: "5px",
                      marginLeft: "470px",
                    }}
                  >
                    <div style={{ marginTop: "27px", marginLeft: "8px" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="18"
                        viewBox="0 0 16 18"
                        fill="none"
                        onClick={() => handleRemoveFieldsProximosPassos(index)}
                      >
                        <path
                          d="M5 0V1H0V3H1V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H13C13.5304 18 14.0391 17.7893 14.4142 17.4142C14.7893 17.0391 15 16.5304 15 16V3H16V1H11V0H5ZM5 5H7V14H5V5ZM9 5H11V14H9V5Z"
                          fill="#EC0000"
                        />
                      </svg>
                    </div>

                    <div style={{ marginTop: "26px" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="21"
                        viewBox="0 0 26 23"
                        fill="none"
                        onClick={handleAddFieldsProximosPassos}
                      >
                        <rect width="26" height="23" rx="4" fill="#B7D400" />
                        <path
                          d="M20 13H14V19H12V13H6V11H12V5H14V11H20V13Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="card"
                    style={{ marginLeft: "53px", marginTop: "35px" }}
                  >
                    <Editor
                      value={ata?.proximosPassos[index]?.editorValue || ""}
                      onTextChange={(e) => {
                        const updatedproximosPassos = [...proximosPassos];
                        updatedproximosPassos[index].editorValue = e.textValue;
                        setProximosPassos(updatedproximosPassos);
                      }}
                      style={{ height: "150px" }}
                      disabled={!isEnabled}
                    />
                  </div>

                  <fieldset
                    style={{
                      borderRadius: "4px",
                      borderColor: "#006998",
                      marginLeft: "54px",
                      width: "500px",
                      height: "59px",
                      marginTop: "40px",
                    }}
                  >
                    <legend
                      style={{
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "black",
                        marginLeft: "-36px",
                      }}
                    >
                      {" "}
                      Responsável
                    </legend>
                    <InputText
                      style={{
                        marginTop: "-31px",
                        height: "30px",
                        backgroundColor: "#F2FBFF",
                        border: "none",
                      }}
                      value={atv.responsavel || ""}
                      onChange={(e) => {
                        console.log({ index, e });
                        handleChangeInputProximosPassos(
                          index,
                          e,
                          "responsavel"
                        );
                      }}
                      disabled={!isEnabled}
                    />
                  </fieldset>
                  <fieldset
                    style={{
                      borderRadius: "4px",
                      borderColor: "#006998",
                      marginLeft: "54px",
                      width: "500px",
                      height: "59px",
                      marginTop: "40px",
                    }}
                  >
                    <legend
                      style={{
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "black",
                        marginLeft: "-36px",
                      }}
                    >
                      Prazo
                    </legend>
                    <Calendar
                      style={{
                        borderRadius: 6,
                        width: "300px",
                        marginLeft: "-22px",
                        marginTop: "2px",
                        border: "none",
                        height: "2px",
                      }}
                      inputStyle={{
                        backgroundColor: "#F2FBFF",
                        border: "none",
                      }}
                      inputId="birth_date"
                      value={new Date(ata?.proximosPassos[index]?.prazo) || ""}
                      onChange={(e) =>
                        handleChangeInputProximosPassos(index, e, "prazo")
                      }
                      disabled={!isEnabled}
                      dateFormat="dd/mm/yy"
                    />
                  </fieldset>
                </div>
              ))}

              <div style={{ display: "flex", marginLeft: "700px" }}>
                <div style={{ marginRight: "10px" }}>
                  <Button
                    label="Cancelar"
                    className="p-button-outlined p-button-primary"
                    style={{ color: "red", fontWeight: "600" }}
                    onClick={handleCancelarClick}
                  />
                </div>

                {/* Modal de confirmação */}
                <Dialog
                  visible={mostrarModal}
                  style={{
                    width: "450px",
                    borderColor: "red",
                    fontWeight: "600",
                    color: "black",
                  }}
                  onHide={() => setMostrarModal(false)}
                >
                  <div className="p-d-flex p-ai-center">
                    <i
                      className="pi pi-exclamation-triangle p-mr-2"
                      style={{
                        fontSize: "3rem",
                        color: "#EC0000",
                        marginTop: "-2px",
                        marginLeft: "100px",
                      }}
                    />
                    <h5
                      style={{
                        color: "#EC0000",
                        fontSize: "20px",
                        marginTop: "-43px",
                        marginLeft: "160px",
                      }}
                    >
                      Atenção !
                    </h5>
                  </div>

                  <p style={{ fontWeight: "400" }}>
                    Você tem alterçoes não salvas. Deseja sair assim mesmo? Caso
                    saia suas <strong>alterações serão perdidas.</strong>
                  </p>
                  <div
                    style={{
                      marginTop: "40px",
                      marginLeft: "190px",
                      gap: "1rem",
                      display: "flex",
                    }}
                  >
                    <Button
                      label="Cancelar"
                      className="p-button-outlined p-button-primary"
                      style={{ color: "red", fontWeight: "600" }}
                      onClick={handleCancelarModal}
                    />

                    <Button
                      label="Sair"
                      className="p-button-outlined p-button-primary"
                      style={{
                        color: "white",
                        fontWeight: "600",
                        backgroundColor: "red",
                      }}
                      onClick={handleConfirmarCancelamento}
                    />
                  </div>
                </Dialog>
                <div>
                  <Button
                    label="Confirmar"
                    className="p-button-outlined p-button-primary"
                    style={{
                      color: "#FFF",
                      fontSize: "16px",
                      backgroundColor: "#3900DB",
                      fontWeight: "600",
                    }}
                    onClick={submitHandler}
                  />
                </div>
              </div>
            </Paper>
            <br />

            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditarAta;
